module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "paeroa"
    }
  }, [_c('h1', [_vm._v("Paeroa")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("We’ve been in Paeroa now nearly two years")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("Really don’t miss Auckland apart from the free beers")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("’Cause I worked in a brewery for a while")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("And the free beer allocation did make my husband smile")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("We love it in Paeroa because")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("Being retired now, it’s made us pause")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("And realise what is important to us")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("It’s not buying things or making a fuss")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("Our lives now are peaceful and uncomplicated")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("Retirement to us was totally underrated")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("We can work in the community and help people out")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("And make a small difference, there is no doubt")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("So, thank you Paeroa, for welcoming us here")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("It’s the best decision we ever made that year")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ec7193a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch005.vue
// module id = 75
// module chunks = 0